module.exports = __webpack_public_path__ + "img/venuethree-zrw-active.cbadfabb.png";